import getUrlParam from 'utils/getUrlParam';
import { COOKIE_PARA_NAME_FOR_JOURNEY_ID } from './Constants';
import StorageKeys from './StorageKeys';

function API() {
  this.sessionToken = global.token;
  this.version = global.version;
  return {
    getCommonHeaderParams() {
      return {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        // 'agent-unique-id': baseConfig.agentId
      };
    },
    setSessionToken(token) {
      this.sessionToken = token;
    },
    setVersion(data) {
      this.version = data;
    },
    async getSessionToken(url) {
      let token = await sessionStorage.getItem(StorageKeys.AUTH_TOKEN);

      return token ? token : '';
    },
    async getCommonHeadersWithToken(url) {

      let selectedPage = getUrlParam(location?.pathname)
      let sessionToken = await this.getSessionToken(url)
      let journeyId = sessionStorage.getItem(COOKIE_PARA_NAME_FOR_JOURNEY_ID)

      if (journeyId) {
        return {
          ...this.getCommonHeaderParams(),
          Authorization: sessionToken,
          Journeyid: journeyId,
          screen: selectedPage
        };

      } else {
        return {
          ...this.getCommonHeaderParams(),
          Authorization: sessionToken,
          screen: selectedPage
        };
      }
    }
  };
}

export default new API();
